export default "__VITE_ASSET__d0b98da4__"